import LTR from "@brand-icons/global/pin-other-store-default/pin-other-store-default-ltr.svg";

import { iconFactory } from "../iconFactory";

export const PinOtherStoreDefaultIcon = iconFactory("PinOtherStoreDefaultIcon", LTR);
